"use client";

import dynamic from "next/dynamic";
import { renderNothingIfChunkFails } from "@/lib/optional-chunk";

export const HiddenBetsManager = dynamic(
  () =>
    renderNothingIfChunkFails(
      import("@/components/dismissed-bets/hidden-bets-manager").then((mod) => mod.HiddenBetsManager),
    ),
  { ssr: false },
);
